import { createSelector, OutputSelector } from "reselect"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const languageIdSelector = (state: any) => state.options.language

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const prefixSelector: OutputSelector<any, undefined, string> = createSelector(
  [languageIdSelector],
  (language: string) => `/${language}`,
)

export default prefixSelector
